module.exports = __webpack_public_path__ + "img/FreeTopPictureOffer.0b189d4b.png";